import React, { useState } from 'react';
import { Link } from 'react-router-dom';
import { MapPin, Phone, Mail, Instagram, Facebook } from 'lucide-react';
import axios from 'axios';
import { toast } from 'sonner';

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;

export const Footer = () => {
  const [email, setEmail] = useState('');
  const [isSubmitting, setIsSubmitting] = useState(false);

  const handleNewsletterSubmit = async (e) => {
    e.preventDefault();
    if (!email) return;

    setIsSubmitting(true);
    try {
      await axios.post(`${BACKEND_URL}/api/newsletter/subscribe`, { email });
      toast.success('Merci pour votre inscription !');
      setEmail('');
    } catch (error) {
      toast.error("Erreur lors de l'inscription");
    } finally {
      setIsSubmitting(false);
    }
  };

  return (
    <footer className="bg-[#3E2723] text-white">
      <div className="container-padding max-w-7xl mx-auto py-16">
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-12">
          {/* Brand */}
          <div className="space-y-4">
            <h3 className="font-heading text-2xl font-bold">
              Racines <span className="text-terracotta">&</span> Épices
            </h3>
            <p className="text-white/70 text-sm leading-relaxed">
              Des plats cuisinés avec passion, préparés avec les meilleurs ingrédients et livrés chez vous à Genève.
            </p>
            <div className="flex space-x-4 pt-4">
              <a href="#" className="text-white/60 hover:text-terracotta transition-colors">
                <Instagram size={22} />
              </a>
              <a href="#" className="text-white/60 hover:text-terracotta transition-colors">
                <Facebook size={22} />
              </a>
            </div>
          </div>

          {/* Navigation */}
          <div className="space-y-4">
            <h4 className="font-heading text-lg font-semibold">Navigation</h4>
            <nav className="flex flex-col space-y-2">
              <Link to="/" className="text-white/70 hover:text-terracotta transition-colors">Accueil</Link>
              <Link to="/menu" className="text-white/70 hover:text-terracotta transition-colors">Notre Carte</Link>
              <Link to="/reviews" className="text-white/70 hover:text-terracotta transition-colors">Avis Clients</Link>
              <Link to="/about" className="text-white/70 hover:text-terracotta transition-colors">Notre Histoire</Link>
            </nav>
          </div>

          {/* Contact */}
          <div className="space-y-4">
            <h4 className="font-heading text-lg font-semibold">Contact</h4>
            <div className="space-y-3 text-sm">
              <div className="flex items-start space-x-3 text-white/70">
                <MapPin size={18} className="mt-0.5 flex-shrink-0" />
                <span>Rue Pré-Bouvier 29<br />1242 Satigny, Suisse</span>
              </div>
              <div className="flex items-center space-x-3 text-white/70">
                <Phone size={18} className="flex-shrink-0" />
                <a href="tel:+41798248630" className="hover:text-terracotta transition-colors" data-testid="footer-phone-link">
                  +41 79 824 86 30
                </a>
              </div>
              <div className="flex items-center space-x-3 text-white/70">
                <Mail size={18} className="flex-shrink-0" />
                <a href="mailto:contact@racines-epices-dumonde.ch" className="hover:text-terracotta transition-colors" data-testid="footer-email-link">
                  contact@racines-epices-dumonde.ch
                </a>
              </div>
            </div>
          </div>

          {/* Newsletter */}
          <div className="space-y-4">
            <h4 className="font-heading text-lg font-semibold">Newsletter</h4>
            <p className="text-white/70 text-sm">
              Recevez nos offres exclusives et découvrez nos nouvelles recettes.
            </p>
            <form onSubmit={handleNewsletterSubmit} className="space-y-3">
              <input
                type="email"
                value={email}
                onChange={(e) => setEmail(e.target.value)}
                placeholder="Votre email"
                className="w-full bg-white/10 border border-white/20 rounded-xl px-4 py-3 text-white placeholder:text-white/40 focus:outline-none focus:border-terracotta"
                data-testid="newsletter-email-input"
              />
              <button
                type="submit"
                disabled={isSubmitting}
                className="w-full btn-primary disabled:opacity-50"
                data-testid="newsletter-submit-button"
              >
                {isSubmitting ? 'Inscription...' : "S'inscrire"}
              </button>
            </form>
          </div>
        </div>

        <hr className="border-white/10 my-12" />

        <div className="flex flex-col md:flex-row justify-between items-center space-y-4 md:space-y-0 text-sm text-white/50">
          <p>© 2026 Racines et Épices du Monde. Tous droits réservés.</p>
          <div className="flex space-x-6">
            <Link to="/privacy" className="hover:text-white transition-colors">Politique de confidentialité</Link>
            <Link to="/terms" className="hover:text-white transition-colors">CGV</Link>
          </div>
        </div>
      </div>
    </footer>
  );
};
